module.exports = __webpack_public_path__ + "static/media/icon_google_logo.d6e872cf.svg";